
export default class Cookie {
  private static setCookie(name: string, value: string) {
    document.cookie = `${name}=${value}`
  }

  private static getCookieValue(name: string): string | undefined {
    const match = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)')
    return match ? match.pop() : ''
  }

  public static get background(): string | undefined {
    return this.getCookieValue('background')
  }

  public static set background(val: string | undefined) {
    if (val)
      this.setCookie('background', val)
  }

  public static get nick(): string | undefined {
    return this.getCookieValue('nick')
  }

  public static set nick(val: string | undefined) {
    if (val)
      this.setCookie('nick', val)
  }
}
